import logo from "../../assets/common/logo.webp";
import { useState, useEffect } from "react";

import useMediaQuery from "@mui/material/useMediaQuery";
import { createTheme } from "@mui/material/styles";
import NavbarMobile from "./navbar-mobile";

import NavBarProdutos from "./navbar-produtos";
import { ICategoria } from "../../interfaces/produto/categoria";

import LanguageSelector from "./language-selector";
import { Link, useLocation } from "react-router-dom";

export default function HeaderPimaco(props: {
  categorias: ICategoria[];
  setHasOpenMenu: Function;
}) {
  const theme = createTheme();

  const [showSearchBar, setShowSearchBar] = useState<boolean>(false);
  const [showMenuProdutos, setShowMenuProdutos] = useState<boolean>(false);
  const [showMenuInstitucional, setShowMenuInstitucional] = useState<boolean>(false);
  const [showMenuDownloads, setShowMenuDownloads] = useState<boolean>(false);

  const matches = useMediaQuery(theme.breakpoints.down("lg"));

  const [isExpandedMobile] = useState<boolean>(false);
  const location = useLocation();

  const handleCloseMenus = () => {
    setShowSearchBar(false);
    setShowMenuProdutos(false);
    setShowMenuInstitucional(false);
    setShowMenuDownloads(false);
  };

  function resizeHeaderOnScroll() {
    if (typeof window !== "undefined") {
      const distanceY = window.scrollY || document.documentElement.scrollTop,
        shrinkOn = 180,
        headerEl = document.getElementById("logo");

      if (headerEl) {
        if (distanceY > shrinkOn) {
          headerEl.classList.add("small-logo");
        } else if (distanceY <= shrinkOn - 60) {
          headerEl.classList.remove("small-logo");
        } else {
        }
      }
    }
  }

  useEffect(() => {
    if (showSearchBar || showMenuProdutos || showMenuInstitucional || showMenuDownloads) {
      props.setHasOpenMenu(true);
    } else {
      props.setHasOpenMenu(false);
    }
  }, [showSearchBar, showMenuProdutos, showMenuInstitucional, showMenuDownloads, props]);

  useEffect(() => {
    if (typeof window !== "undefined") {
      window.addEventListener("scroll", resizeHeaderOnScroll);
    }
  });

  useEffect(() => {
    handleCloseMenus();
  }, [location.pathname]);

  return (
    <header className="header" id="header">
      <div className="header-top-half-container">
        <div className="logo-row-container">
          <Link to="https://www.pimaco.com.br" title="logo-pimaco">
            <img src={logo} className="logo" title="logo" id="logo" alt="logo" />
          </Link>
          {!matches ? <LanguageSelector /> : ""}
        </div>
      </div>

      {matches && isExpandedMobile ? <NavbarMobile categorias={props.categorias} /> : ""}

      {showMenuProdutos ? (
        <NavBarProdutos categorias={props.categorias} handleCloseMenus={handleCloseMenus} />
      ) : (
        ""
      )}
    </header>
  );
}
